<template>
  <el-drawer
    :visible="dialogVisible"
    direction="rtl"
    :size="drawerSize"
    destroy-on-close
    :before-close="handleDrawerBeforeClose"
    custom-class="product-form-drawer"
    :with-header="false"
  >
    <div class="detail-workspace" v-loading="loading">
      <div class="breadcrumb-header">
        <div class="header-top-row">
          <div class="header-left">
            <span class="header-title">
              <span class="header-title-icon"><i :class="type ? 'el-icon-edit-outline' : 'el-icon-plus'"></i></span>
              {{ type ? `编辑：${form.id} - ${form.name || ''}` : '新增游戏' }}
            </span>
            <span class="header-subtitle">游戏主体配置</span>
          </div>

          <div class="header-right-buttons">
            <el-button size="small" @click="handleCloseProductDialog"><i class="el-icon-back"></i> 返回列表</el-button>
            <el-button type="success" size="small" @click="handleSaveDialog">保存</el-button>
          </div>
        </div>
      </div>

      <div class="detail-content box">
        <el-form :model="form" label-position="right" label-width="130px" :rules="rules" ref="form" size="small" class="form-container">
          <div class="form-section">
            <div class="panel-section-header">
              <div class="panel-title-icon"><i class="el-icon-s-management"></i></div>
              <div>
                <h3 class="panel-section-title">基础属性</h3>
                <p class="section-subtitle">游戏主体信息、密钥与常用开关。</p>
              </div>
            </div>

            <el-form-item label="游戏 ID" prop="id">
              <el-input v-model.number="form.id" :disabled="type" placeholder="请输入 ID"></el-input>
            </el-form-item>

            <el-form-item label="游戏名称" prop="name">
              <el-input v-model.trim="form.name" placeholder="请输入游戏名称"></el-input>
            </el-form-item>

            <el-form-item label="所属公司" prop="companyId">
              <el-select v-model="form.companyId" placeholder="请选择公司" style="width: 100%">
                <el-option v-for="item in companyData" :key="item.id" :label="item.id + ' - ' + item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="货币类型" prop="currency">
              <el-select v-model="form.currency" placeholder="请选择货币类型" style="width: 100%">
                <el-option v-for="item in currencyOptions" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="AppKey" prop="appKey">
              <el-input v-model.trim="form.appKey" placeholder="请输入 appKey"></el-input>
            </el-form-item>

            <el-form-item label="AppSecret" prop="appSecret">
              <el-input v-model.trim="form.appSecret" placeholder="请输入 appSecret"></el-input>
            </el-form-item>

            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择游戏状态" style="width: 100%">
                <el-option v-for="item in productStatusOption" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="UFW 开关" prop="ufwOpen" class="switch-form-item">
              <el-switch v-model="form.ufwOpen"></el-switch>
            </el-form-item>

            <el-form-item label="手机号绑定" prop="phoneBindOpen" class="switch-form-item">
              <el-switch v-model="form.phoneBindOpen"></el-switch>
            </el-form-item>

            <el-form-item label="Pluto 开关" prop="plutoOpen" class="switch-form-item">
              <el-switch v-model="form.plutoOpen"></el-switch>
            </el-form-item>

            <el-form-item label="转端开关" prop="transferOpen" class="switch-form-item">
              <el-switch v-model="form.transferOpen"></el-switch>
            </el-form-item>

            <el-form-item label="卸载菜单栏" prop="uninstallMenuOpen" class="switch-form-item">
              <el-switch v-model="form.uninstallMenuOpen"></el-switch>
            </el-form-item>

            <el-form-item label="预约归因" prop="reserveAttributeOpen" class="switch-form-item">
              <el-switch v-model="form.reserveAttributeOpen"></el-switch>
            </el-form-item>
          </div>

          <div class="form-section">
            <div class="panel-section-header">
              <div class="panel-title-icon"><i class="el-icon-link"></i></div>
              <div>
                <h3 class="panel-section-title">网关域名与回调</h3>
                <p class="section-subtitle">配置环境域名、CP 回调地址和 UFO 分组。</p>
              </div>
            </div>

            <el-form-item label="网关域名" prop="areaId">
              <el-select v-model="form.areaId" filterable placeholder="请选择网关域名" style="width: 100%" @change="handleChangeAreaArgs(form.areaId)" clearable>
                <el-option v-for="area in areaData" :key="area.id" :label="area.id + ' - ' + area.name" :value="area.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="CP-NotifyUrl" prop="notifyUrl">
              <el-input v-model.trim="form.notifyUrl" placeholder="请输入 CP NotifyUrl"></el-input>
            </el-form-item>

            <el-form-item label="CP-H5Url" prop="h5LoginUrl">
              <el-input v-model.trim="form.h5LoginUrl" placeholder="请输入 CP H5LoginUrl"></el-input>
            </el-form-item>

            <el-form-item label="CP-微端Url" prop="gameUrl">
              <el-input v-model.trim="form.gameUrl" placeholder="请输入 CP 微端 GameUrl"></el-input>
            </el-form-item>

            <el-form-item label="UFO 分组" prop="ufoGroup">
              <el-select v-model="form.ufoGroup" placeholder="请选择 UFO 分组" style="width: 100%">
                <el-option value="">不分组</el-option>
                <el-option v-for="item in ufoGroupOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="form-section">
            <div class="panel-section-header">
              <div class="panel-title-icon"><i class="el-icon-warning-outline"></i></div>
              <div>
                <h3 class="panel-section-title">备案与防沉迷</h3>
                <p class="section-subtitle">管理合规备案、适龄和实名防沉迷能力。</p>
              </div>
            </div>

            <el-form-item label="备案识别码" prop="bizId">
              <el-input v-model="form.bizId" placeholder="请输入备案识别码 bizId"></el-input>
            </el-form-item>

            <el-form-item label="适龄限制" prop="minAge">
              <el-input-number v-model="form.minAge" :min="0" :max="100" style="width: 100%"></el-input-number>
            </el-form-item>

            <el-form-item label="实名认证" prop="realAuthOpen" class="switch-form-item">
              <el-switch v-model="form.realAuthOpen"></el-switch>
            </el-form-item>

            <el-form-item label="防沉迷" prop="juvenileOpen" class="switch-form-item">
              <el-switch v-model="form.juvenileOpen"></el-switch>
            </el-form-item>
          </div>

          <div class="form-section">
            <div class="panel-section-header">
              <div class="panel-title-icon"><i class="el-icon-more-outline"></i></div>
              <div>
                <h3 class="panel-section-title">其他配置</h3>
                <p class="section-subtitle">客服与应用商店补充配置。</p>
              </div>
            </div>

            <el-form-item label="七鱼AppKey" prop="qyAppKey">
              <el-input v-model.trim="form.qyAppKey" placeholder="请输入七鱼客服 appKey"></el-input>
            </el-form-item>

            <el-form-item label="七鱼GroupId" prop="qyGroupId">
              <el-input v-model.trim="form.qyGroupId" placeholder="请输入七鱼客服 groupId"></el-input>
            </el-form-item>

            <el-form-item label="AppStoreId" prop="appStoreId">
              <el-input v-model="form.appStoreId" placeholder="请输入 AppStoreId"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import api from '@/api/channel'
import options from '../../common/options'

export default {
  name: 'ProductDialog',
  props: {
    dialogVisible: Boolean,
    productData: Object
  },
  watch: {
    productData: function (val) {
      this.fetchData()
      this.type = !!val.name
      this.form = Object.assign({}, val)
    }
  },
  data () {
    return {
      viewportWidth: window.innerWidth,
      loading: false,
      productStatusOption: options.productStatusOption,
      currencyOptions: options.currency,
      form: {
        status: 1,
        currency: 'CNY',
        gatewayUrl: 'https://sgw.begindcc.com',
        realAuthOpen: false,
        phoneBindOpen: false,
        reserveAttributeOpen: false,
        juvenileOpen: false,
        plutoOpen: false,
        ufwOpen: false,
        minAge: 0,
        bizId: '',
        areaId: '',
        ufoGroup: '',
        qyAppKey: '',
        qyGroupId: '',
        uninstallMenuOpen: false,
        transferOpen: false
      },
      companyData: [],
      areaData: [],
      type: '',
      rules: {
        id: [{ type: 'number', required: true, message: '请输入数字，且不能为空', trigger: 'change' }],
        companyId: [{ type: 'number', required: true, message: '请先选择公司', trigger: 'blur' }],
        appKey: [{ type: 'string', required: true, message: 'appKey不能为空', trigger: 'blur' }],
        appSecret: [{ type: 'string', required: true, message: 'appSecret不能为空', trigger: 'blur' }],
        appStoreId: [{ type: 'string', required: false, message: '请输入appStoreId', trigger: 'blur' }],
        currency: [{ type: 'string', required: false, message: '请选择货币类型', trigger: 'blur' }],
        areaId: [{ type: 'number', required: true, min: 1, message: '请选择网关域名', trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '请输入游戏名称', trigger: 'blur' }],
        notifyUrl: [{ type: 'url', required: true, message: 'NotifyUrl格式不正确', trigger: 'blur' }],
        h5LoginUrl: [{ type: 'url', required: false, message: 'h5LoginUrl格式不正确', trigger: 'blur' }],
        gameUrl: [{ type: 'url', required: false, message: 'gameUrl格式不正确', trigger: 'blur' }]
      },
      ufoGroupOptions: []
    }
  },
  computed: {
    drawerSize () {
      if (this.viewportWidth <= 768) return '100%'
      if (this.viewportWidth <= 1200) return '72%'
      return '50%'
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.viewportWidth = window.innerWidth
    },
    fetchData () {
      this.loading = true
      Promise.all([
        api.getCompanyData(),
        api.getAreas(),
        api.getUfoGroups()
      ]).then(([companies, areas, groups]) => {
        this.companyData = companies || []
        this.areaData = areas || []
        const arr = []
        for (const d of (groups || [])) {
          arr.push({ value: d.groupKey, label: d.groupKey })
        }
        this.ufoGroupOptions = arr
      }).finally(() => {
        this.loading = false
      })
    },
    handleCloseProductDialog () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
      this.$emit('handleCloseProductDialog', false)
    },
    handleDrawerBeforeClose (done) {
      this.handleCloseProductDialog()
      done()
    },
    handleChangeAreaArgs (areaId) {
      for (const item of this.areaData) {
        if (item.id === areaId) {
          this.$store.state.app.gatewayUrl = item.callbackUrl
        }
      }
    },
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form)
          params.products = null
          const f = this.type ? api.changeProduct : api.addProduct
          f(params).then(res => {
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.$emit('handleSaveProductDialog', res)
            this.$store.dispatch('UpdateAppInfo', res).then(() => {})
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.detail-workspace {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  background-color: #f8fafc;
}

.breadcrumb-header {
  position: sticky;
  top: 0;
  z-index: 100;
  margin: 0;
  padding: 12px 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #E2E8F0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.header-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.header-title {
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.header-title-icon {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.header-subtitle {
  font-size: 12.5px;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 4px 10px;
  white-space: nowrap;
}

.header-right-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.detail-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 18px 20px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.form-section {
  padding-bottom: 14px;
  margin-bottom: 18px;
  border-bottom: 1px solid #F1F5F9;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.panel-section-header {
  margin-bottom: 18px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F1F5F9;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: center;
}

.panel-title-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-section-title {
  margin: 0;
  font-size: 15px;
  color: #1E293B;
  font-weight: 700;
}

.section-subtitle {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: #64748B;
}

.form-container {
  max-width: none;
  width: 100%;
}

.form-container :deep(.el-form-item) {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.form-container :deep(.el-form-item__label) {
  flex: 0 0 25%;
  width: 25% !important;
  min-width: 112px;
  max-width: 180px;
  text-align: left;
  padding-right: 12px;
  color: #475569;
  font-weight: 600;
  line-height: 32px;
}

.form-container :deep(.el-form-item__content) {
  flex: 1 1 75%;
  margin-left: 0 !important;
  min-width: 0;
}

.form-container :deep(.el-input-number),
.form-container :deep(.el-select) {
  width: 100%;
}

.switch-form-item :deep(.el-form-item__content) {
  display: flex;
  align-items: center;
  min-height: 32px;
}

@media (max-width: 768px) {
  .breadcrumb-header {
    padding: 12px 16px;
  }

  .header-top-row,
  .header-left {
    align-items: flex-start;
    flex-direction: column;
  }

  .header-right-buttons {
    width: 100%;
    justify-content: flex-end;
  }

  .form-container :deep(.el-form-item) {
    display: block;
  }

  .form-container :deep(.el-form-item__label) {
    width: 100% !important;
    max-width: none;
    padding-right: 0;
  }
}
</style>
